import type { ThemeDefinition } from 'vuetify'

export const staticPrimaryColor = '#fdb817' // Màu chính
export const staticPrimaryDarkenColor = '#e0a30b' // Màu chính tối hơn (tùy chọn)
export const staticSecondaryColor = '#0047ff' // Màu phụ
export const staticSecondaryDarkenColor = '#0039cc' // Màu phụ tối hơn (tùy chọn)

export const themes: Record<string, ThemeDefinition> = {
  light: {
    dark: false,
    colors: {
      'primary': staticPrimaryColor,
      'on-primary': '#fff',
      'primary-darken-1': staticPrimaryDarkenColor,
      'secondary': staticSecondaryColor,
      'secondary-darken-1': staticSecondaryDarkenColor,
      'on-secondary': '#000', // Đã thay đổi thành #000 để dễ đọc trên nền vàng
      'success': '#56CA00',
      'success-darken-1': '#4DB600',
      'on-success': '#fff',
      'info': '#16B1FF',
      'info-darken-1': '#149FE6',
      'on-info': '#fff',
      'warning': '#FFB400',
      'warning-darken-1': '#E6A200',
      'on-warning': '#fff',
      'error': '#FF4C51',
      'error-darken-1': '#E64449',
      'on-error': '#fff',
      'background': '#f4f5fa',
      'aside-background': '#ccebff', // Xanh sáng
      'on-background': '#2E263D',
      'surface': '#fff',
      'on-surface': '#2E263D',
      'grey-50': '#FAFAFA',
      'grey-100': '#F5F5F5',
      'grey-200': '#EEEEEE',
      'grey-300': '#E0E0E0',
      'grey-400': '#BDBDBD',
      'grey-500': '#9E9E9E',
      'grey-600': '#757575',
      'grey-700': '#616161',
      'grey-800': '#424242',
      'grey-900': '#212121',
      'perfect-scrollbar-thumb': '#dbdade',
      'skin-bordered-background': '#fff',
      'skin-bordered-surface': '#fff',
      'expansion-panel-text-custom-bg': '#fafafa',
      'track-bg': '#F0F2F8',
      'chat-bg': '#F7F6FA',
    },

    variables: {
      'code-color': '#d400ff',
      'overlay-scrim-background': '#2E263D',
      'tooltip-background': '#1A0E33',
      'overlay-scrim-opacity': 0.5,
      'hover-opacity': 0.04,
      'focus-opacity': 0.1,
      'selected-opacity': 0.08,
      'activated-opacity': 0.16,
      'pressed-opacity': 0.14,
      'dragged-opacity': 0.1,
      'disabled-opacity': 0.4,
      'border-color': '#2E263D',
      'border-opacity': 0.12,
      'table-header-color': '#F6F7FB',
      'high-emphasis-opacity': 0.9,
      'medium-emphasis-opacity': 0.7,

      // 👉 shadows
      'shadow-key-umbra-color': '#2E263D',
      'shadow-xs-opacity': '0.16',
      'shadow-sm-opacity': '0.18',
      'shadow-md-opacity': '0.20',
      'shadow-lg-opacity': '0.22',
      'shadow-xl-opacity': '0.24',
    },
  },

  dark: {
    dark: true,
    colors: {
      'primary': staticPrimaryColor, // Vẫn giữ màu chính (nếu muốn)
      'on-primary': '#fff',
      'primary-darken-1': staticPrimaryDarkenColor,
      'secondary': staticSecondaryColor, // Vẫn giữ màu phụ (nếu muốn)
      'secondary-darken-1': staticSecondaryDarkenColor,
      'on-secondary': '#000',
      'success': '#56CA00',
      'success-darken-1': '#4DB600',
      'on-success': '#fff',
      'info': '#16B1FF',
      'info-darken-1': '#149FE6',
      'on-info': '#fff',
      'warning': '#FFB400',
      'warning-darken-1': '#E6A200',
      'on-warning': '#fff',
      'error': '#FF4C51',
      'error-darken-1': '#E64449',
      'on-error': '#fff',
      'background': '#1E283A', // Xanh tối
      'aside-background': '#001159', // Xanh tối
      'on-background': '#D0D8E6', // Màu chữ sáng hơn trên nền xanh
      'surface': '#283345', // Xanh tối hơn một chút
      'on-surface': '#D0D8E6', // Màu chữ sáng hơn trên nền xanh
      'grey-50': '#232D3F', // Các màu xám cũng được điều chỉnh cho phù hợp
      'grey-100': '#283345',
      'grey-200': '#333E50',
      'grey-300': '#3E495B',
      'grey-400': '#495466',
      'grey-500': '#545F71',
      'grey-600': '#5F6A7C',
      'grey-700': '#6A7587',
      'grey-800': '#758092',
      'grey-900': '#808BA3',
      'perfect-scrollbar-thumb': '#495466',
      'skin-bordered-background': '#283345',
      'skin-bordered-surface': '#283345',
      'expansion-panel-text-custom-bg': '#2E394B',
      'track-bg': '#333E50',
      'chat-bg': '#2E394B',
    },

    variables: {
      'code-color': '#90CAF9', // Xanh sáng cho code
      'overlay-scrim-background': '#999999',
      'tooltip-background': '#f1f1f1',
      'overlay-scrim-opacity': 0.5,
      'hover-opacity': 0.04,
      'focus-opacity': 0.1,
      'selected-opacity': 0.08,
      'activated-opacity': 0.16,
      'pressed-opacity': 0.14,
      'disabled-opacity': 0.4,
      'dragged-opacity': 0.1,
      'border-color': '#D0D8E6', // Viền sáng
      'border-opacity': 0.12,
      'table-header-color': '#384355', // Xanh tối cho header bảng
      'high-emphasis-opacity': 0.9,
      'medium-emphasis-opacity': 0.7,

      // 👉 Shadows
      'shadow-key-umbra-color': '#18202F', // Màu shadow tối hơn
      'shadow-xs-opacity': '0.20',
      'shadow-sm-opacity': '0.22',
      'shadow-md-opacity': '0.24',
      'shadow-lg-opacity': '0.26',
      'shadow-xl-opacity': '0.28',
    },
  },
}

export default themes
